// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"188":"922f311583b08bd3","665":"8e84536a0e5741d4","769":"717c6cb91ccf6f72","889":"87cce80d19df3dd1","912":"7a5add9c05a7f932"}[chunkId] + ".js";
};